import { render, staticRenderFns } from "./AppAlertsDictionary.vue?vue&type=template&id=122d40d7&scoped=true&"
import script from "./AppAlertsDictionary.vue?vue&type=script&lang=js&"
export * from "./AppAlertsDictionary.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertsDictionary.vue?vue&type=style&index=0&id=122d40d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122d40d7",
  null
  
)

export default component.exports